import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';
import { 
  Buildings, 
  CookingPot, 
  GameController, 
  Toilet, 
  OfficeChair, 
  Wrench,
  Bank,
  House,
  HouseLine,
  Ruler
} from '@phosphor-icons/react';

const services = [
  { icon: Buildings, label: 'Commercial Bar Construction & Renovations' },
  { icon: CookingPot, label: 'Commercial Kitchen Upgrades' },
  { icon: GameController, label: 'Gaming Room Renovations' },
  { icon: Toilet, label: 'Commercial Bathroom Upgrades & Renovations' },
  { icon: OfficeChair, label: 'Office Fitouts & Upgrades' },
  { icon: Wrench, label: 'Commercial Maintenance & Rectification Works' },
  { icon: Bank, label: 'ATM Relocations' },
  { icon: House, label: 'Re-Roofing' },
  { icon: HouseLine, label: 'Residential New Builds' },
  { icon: Ruler, label: 'Renovations & Extensions' },
];

const Services = () => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  const doubledServices = [...services, ...services];

  return (
    <section 
      id="services" 
      data-testid="services-section"
      className="py-16 md:py-20 bg-secondary-bg overflow-hidden"
      ref={ref}
    >
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-10"
        >
          <p className="overline mb-3">Our Services</p>
          <h2 
            data-testid="services-heading"
            className="text-3xl sm:text-4xl font-heading font-light text-heading"
          >
            What We Build
          </h2>
        </motion.div>
      </div>

      {/* Scrolling marquee */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={isInView ? { opacity: 1 } : {}}
        transition={{ duration: 0.6, delay: 0.3 }}
        className="relative"
      >
        <div className="absolute left-0 top-0 bottom-0 w-16 bg-gradient-to-r from-secondary-bg to-transparent z-10 pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-16 bg-gradient-to-l from-secondary-bg to-transparent z-10 pointer-events-none" />

        <div className="flex animate-marquee">
          {doubledServices.map((service, index) => (
            <div
              key={`${service.label}-${index}`}
              data-testid={`service-card-${index % services.length}`}
              className="flex-shrink-0 bg-primary-bg border border-border-subtle p-6 mx-2 w-56 min-h-[120px] flex flex-col justify-between"
            >
              <service.icon 
                size={32} 
                weight="light" 
                className="text-accent mb-4" 
              />
              <span className="text-heading text-sm font-medium leading-tight">
                {service.label}
              </span>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Services;
